var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.707 5.924a6.652 6.652 0 1 0 3.945 6.08m0 0v-.72a1.174 1.174 0 1 1 2.348 0v.72a9.002 9.002 0 0 1-12.119 8.438A9 9 0 1 1 15.663 3.78a1.174 1.174 0 1 1-.956 2.145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.656 4.913a1.174 1.174 0 0 1 0 1.66l-7.825 7.834a1.174 1.174 0 0 1-1.661 0L8.822 12.06a1.174 1.174 0 1 1 1.66-1.66L12 11.917l6.996-7.003a1.174 1.174 0 0 1 1.66 0z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tickCircle.4c0c24cf.svg";
export { ForwardRef as ReactComponent };